/**
 * Paper sizes in CSS pixels at 96dpi, so the preview can show the page at the proportions
 * Chromium's page.pdf() will print at.
 *
 * The format list and the A4 fallback mirror PdfRenderer.FORMATS / resolveFormat in
 * templates-service - an unknown format degrades to A4 there, so it must here too.
 */
const PAPER_SIZES = {
  A0: [3179, 4494],
  A1: [2245, 3179],
  A2: [1587, 2245],
  A3: [1123, 1587],
  A4: [794, 1123],
  A5: [559, 794],
  A6: [397, 559],
  LETTER: [816, 1056],
  LEGAL: [816, 1344],
  TABLOID: [1056, 1632],
  LEDGER: [1632, 1056],
};

export const DEFAULT_FORMAT = 'A4';

export const PAPER_FORMATS = ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'Letter', 'Legal', 'Tabloid', 'Ledger'];

export const resolveFormat = format => {
  if (!format || !format.trim()) return DEFAULT_FORMAT;
  const match = PAPER_FORMATS.find(f => f.toLowerCase() === format.trim().toLowerCase());
  return match || DEFAULT_FORMAT;
};

/** @returns {{width: number, height: number}} the page box in CSS pixels. */
export const paperSize = (format, landscape) => {
  const [width, height] = PAPER_SIZES[resolveFormat(format).toUpperCase()];
  return landscape ? { width: height, height: width } : { width, height };
};
